// Wraps the useSoftphone hook in a Context so multiple consumers
// (Softphone widget + Workspace screen-pop + future Supervisor panel) share
// a SINGLE WebSocket connection and a single source of truth for call state.
import { createContext, useContext } from "react";
import { useSoftphone as useSoftphoneInternal } from "@/hooks/useSoftphone";

const SoftphoneCtx = createContext(null);

export function SoftphoneProvider({ children }) {
  const value = useSoftphoneInternal();
  return <SoftphoneCtx.Provider value={value}>{children}</SoftphoneCtx.Provider>;
}

export function useSoftphone() {
  const v = useContext(SoftphoneCtx);
  if (!v) throw new Error("useSoftphone must be used inside SoftphoneProvider");
  return v;
}

// Non-throwing variant — returns null when no SoftphoneProvider is mounted
// (e.g. the AdminLayout Live Dashboard). Used by the supervisor Monitor Phone
// to avoid registering a SECOND SIP engine on the same extension when the
// agent softphone engine is already present (which would double-REGISTER).
export function useSoftphoneOptional() {
  return useContext(SoftphoneCtx);
}
